var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddToGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3827 6.6665V14.6665M14.3827 14.6665H6.62614M14.3827 14.6665L4.00008 4.28385M8.00008 2.6665H17.3334C19.5426 2.6665 21.3334 4.45737 21.3334 6.6665V17.3332C21.3334 19.5423 19.5426 21.3332 17.3334 21.3332H6.66675C4.45761 21.3332 2.66675 19.5423 2.66675 17.3332V7.99984",
    stroke: "#7B7986",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToGroup);
export default __webpack_public_path__ + "static/media/addToGroup.6fe4b01f4ba31af1bb91ab89a08bfec1.svg";
export { ForwardRef as ReactComponent };